// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"c0a149ab","292":"65bd033e","384":"a42ce79a","584":"621e49ee","787":"0e291c02","867":"99a75319","897":"da533045"}[chunkId] + ".chunk.js";
};